/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

// FSP: start the first hero video shortly after the poster has had a chance to paint.
(function () {
  function startFirstHeroVideo() {
    var video = document.querySelector('.fsp-split-carousel .fsp-hero-video[data-priority="high"]');
    if (!video) return;

    var sources = video.querySelectorAll('source[data-src]');
    var attached = false;
    sources.forEach(function (source) {
      if (!source.getAttribute('src') && source.dataset.src) {
        source.setAttribute('src', source.dataset.src);
        attached = true;
      }
    });

    if (attached) video.load();
    video.dataset.loaded = 'true';
    video.muted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    if (!video.dataset.fspEarlyFadeBound) {
      video.addEventListener('playing', function () {
        video.classList.add('is-visible');
      });
      video.dataset.fspEarlyFadeBound = 'true';
    }

    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function scheduleFirstHeroVideo() {
    window.setTimeout(startFirstHeroVideo, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleFirstHeroVideo, { once: true });
  } else {
    scheduleFirstHeroVideo();
  }
})();
